import { FaCity } from 'react-icons/fa';
import { FaBuilding, FaHandshake, FaTimesCircle } from 'react-icons/fa';
import { motion } from 'framer-motion';
import CustomSelect from '../../../utilities/CustomSelect';
import CustomSlider from '../../../utilities/CustomSlider';
import { formatPrice } from '../../../utilities/FormatFunctions';

export default function RealEstatesFilters({
  formik,
  realEstateTypes,
  onChange,
  onReset,
}) {
  const hasActiveFilters =
    Boolean(formik.values.city) ||
    Boolean(formik.values.realEstateTypeId) ||
    Boolean(formik.values.businessType) ||
    Number(formik.values.priceRange) > 0;

  return (
    <>
      <motion.div
        className="bg-zinc-100 p-6 border border-gray-300 shadow-lg w-full rounded-2xl"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, ease: 'easeOut' }}
      >
        <div className="flex items-center justify-between mb-4">
          <span className="text-xl font-heading font-bold text-gray-700">
            Filtros
          </span>
          {hasActiveFilters && (
            <button
              type="button"
              className="text-gray-400 flex items-center group hover:text-gray-600"
              onClick={onReset}
              aria-label="Limpiar filtros"
            >
              <FaTimesCircle className="h-5 w-5 ml-1 mt-1 text-gray-400 group-hover:text-gray-600" />
            </button>
          )}
        </div>
        <form
          onSubmit={formik.handleSubmit}
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6"
        >
          <div>
            <label
              htmlFor="city"
              className="block tracking-wide font-heading text-gray-400 text-sm font-bold mb-2"
            >
              Ciudad
            </label>
            <div className="relative mt-3">
              <CustomSelect
                id="city"
                name="city"
                options={[
                  { value: 'La Ceja', label: 'La Ceja' },
                  { value: 'Rionegro', label: 'Rionegro' },
                  { value: 'El Carmen', label: 'El Carmen' },
                  { value: 'Guarne', label: 'Guarne' },
                  { value: 'El Retiro', label: 'El Retiro' },
                ]}
                value={formik.values.city}
                onChange={(value) => {
                  formik.setFieldValue('city', value);
                  onChange({ target: { name: 'city', value } });
                }}
                placeholder="Seleccione"
                leftIcon={<FaCity />}
              />
            </div>
          </div>
          <div>
            <label
              htmlFor="realEstateTypeId"
              className="block tracking-wide font-heading text-gray-400 text-sm font-bold mb-2"
            >
              Tipo de inmueble
            </label>
            <div className="relative mt-3">
              <CustomSelect
                id="realEstateTypeId"
                name="realEstateTypeId"
                options={realEstateTypes.slice(0, -1).map((realEstateType) => ({
                  value: realEstateType.id,
                  label: realEstateType.name,
                }))}
                value={formik.values.realEstateTypeId}
                onChange={(value) => {
                  formik.setFieldValue('realEstateTypeId', value);
                  onChange({ target: { name: 'realEstateTypeId', value } });
                }}
                placeholder="Seleccione"
                leftIcon={<FaBuilding />} // Icono para tipo de inmueble
              />
            </div>
          </div>
          <div>
            <label
              htmlFor="businessType"
              className="block tracking-wide font-heading text-gray-400 text-sm font-bold mb-2"
            >
              Tipo de negocio
            </label>
            <div className="relative mt-3">
              <CustomSelect
                id="businessType"
                name="businessType"
                options={[
                  { value: 'Venta', label: 'Venta' },
                  { value: 'Arriendo', label: 'Arriendo' },
                ]}
                value={formik.values.businessType}
                onChange={(value) => {
                  formik.setFieldValue('businessType', value);
                  onChange({ target: { name: 'businessType', value } });
                }}
                placeholder="Seleccione"
                leftIcon={<FaHandshake />} // Icono para tipo de negocio
              />
            </div>
          </div>
          <div>
            <label
              htmlFor="priceRange"
              className="block tracking-wide font-heading text-gray-400 text-sm font-bold"
            >
              Rango de precio
            </label>
            <CustomSlider
              min={0}
              max={1000000000}
              step={100000000}
              value={formik.values.priceRange}
              onChange={(value) => {
                formik.setFieldValue('priceRange', value);
                onChange({ target: { name: 'priceRange', value } });
              }}
              marks={{
                ...Array.from({ length: 11 }, (_, i) => i * 100000000).reduce(
                  (acc, val) => {
                    acc[val] = (
                      <span
                        style={{
                          writingMode: 'vertical-lr',
                          transform: 'rotate(180deg)',
                          fontSize: 12,
                        }}
                      >
                        {val === 0 ? '0' : `${val / 1000000}M`}
                      </span>
                    );
                    return acc;
                  },
                  {}
                ),
                1000000000: (
                  <span
                    style={{
                      writingMode: 'vertical-lr',
                      transform: 'rotate(180deg)',
                      fontSize: 12,
                    }}
                  >
                    1B
                  </span>
                ),
              }}
            />
            <span className="text-sm font-base text-gray-400 mt-2">
              <span>Entre </span>
              <span className="text-gray-600 font-semibold">
                ${formatPrice(formik.values.priceRange)}
              </span>
              <span> y </span>
              <span className="text-gray-600 font-semibold">
                ${formatPrice(1000000000)}
              </span>
            </span>
          </div>
        </form>
      </motion.div>
    </>
  );
}
